const PrivacyPolicy = () => {
    return (
        <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 max-w-3xl space-y-8 text-sm text-muted-foreground">
            <section>
                <h1 className="text-3xl font-semibold text-foreground mb-4">Privacy Policy</h1>
                <p className="text-xs text-muted-foreground">Effective date: January 1, 2025</p>
            </section>

            <section className="space-y-3">
                <p>
                    This Privacy Policy explains how ProcessPipe, LLC (“ProcessPipe”, “we”, “us”, or “our”) collects, uses,
                    and shares information about you when you access or use our website, products, and services (collectively, the
                    “Services”). By using the Services, you agree to the terms outlined in this Privacy Policy.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Information We Collect</h2>
                <p>We may collect information that you provide directly to us, including:</p>
                <ul className="list-disc pl-6 space-y-1">
                    <li>Personal identifiers (such as your name, email address, and contact details)</li>
                    <li>Content that you share when participating in community features or providing feedback</li>
                    <li>Billing and payment information when you make purchases or transact within the Services</li>
                </ul>
                <p>
                    We also automatically collect certain information when you access or use the Services, such as device
                    identifiers, log data, usage information, and cookie data. This may include IP addresses, browser type, pages
                    viewed, and other analytics.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">How We Use Information</h2>
                <p>We use the information we collect to:</p>
                <ul className="list-disc pl-6 space-y-1">
                    <li>Provide, maintain, and improve the Services</li>
                    <li>Personalize experiences and recommend content or features</li>
                    <li>Communicate with you about updates, offers, and support</li>
                    <li>Monitor usage trends and protect the security of the Services</li>
                </ul>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Sharing of Information</h2>
                <p>
                    We do not sell your personal information. We may share information with service providers who perform
                    services on our behalf, such as analytics, hosting, and payment processing. We may also share information when
                    required by law, to protect our rights and property, or in connection with a merger, sale, or acquisition.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Your Choices</h2>
                <p>You may:</p>
                <ul className="list-disc pl-6 space-y-1">
                    <li>Update or correct your account information at any time</li>
                    <li>Opt out of promotional emails by following the unsubscribe instructions</li>
                    <li>
                        Adjust cookie preferences through your browser settings or within our Services where cookie consent is
                        offered
                    </li>
                </ul>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Security</h2>
                <p>
                    We implement reasonable safeguards to protect your information, but no security measures are perfect. We
                    cannot guarantee the absolute security of your data.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">International Users</h2>
                <p>
                    If you access the Services from outside the United States, you agree that your information may be transferred
                    to and processed in the United States and other countries.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Changes to This Policy</h2>
                <p>
                    We may update this Privacy Policy from time to time. If we make material changes, we will notify you by
                    revising the effective date at the top of the policy and, in some cases, by providing additional notice.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Contact Us</h2>
                <p>
                    If you have questions about this Privacy Policy or our practices, please contact ProcessPipe, LLC at
                    privacy@processpipe.com.
                </p>
            </section>

            <section className="text-xs text-muted-foreground border-t border-border pt-6">
                <p>© 2025 ProcessPipe, LLC. All rights reserved.</p>
            </section>
        </main>
    )
}

export default PrivacyPolicy

